import { createFileRoute } from '@tanstack/react-router'
import { MarketingShell } from '@/components/admin/marketing/MarketingShell'
import { AdminMarketingQrSettings } from '@/components/admin/AdminMarketingQrSettings'

export const Route = createFileRoute('/admin/marketing/qr-codes')({
  component: () => (
    <MarketingShell
      title="Marketing QR codes"
      description="Trackable codes for menus, promos, and delivery links. Each code carries a permanent short URL — edit the destination later and every printed copy retargets automatically."
    >
      <AdminMarketingQrSettings embedded />
    </MarketingShell>
  ),
})
